module.exports = __webpack_public_path__ + "img/file_image_failed@2x.db744b18.png";